<template>
  <SharedBaseLink
    v-editable="blok"
    :link="blok.link"
    class="util-link-item"
    :class="isDark ? 'is-dark' : 'is-light'"
    @click="trackClick && trackNavigationClick(blok.text)">
    <span class="main-text" :class="{ 'is-reverse': iconPosition === 'left' }">
      <span class="text">{{ blok.text }}</span>
      <BaseIcon v-if="icon" :name="icon" :size="16" color="inherit" class="icon-end" />
    </span>
  </SharedBaseLink>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { SharedBaseLink } from '@seb-platform/shared/components/base';
import { urlIsExternal } from '@seb-platform/shared/utils/url';
import { BaseIcon } from '~/components/base';
import { useGtmTracking } from '~/composables/useGtmTracking';
import type { UtilLinkItemStoryblok } from '~/types/storyblok-generated';
import {
  ICON_EXTERNAL,
  ICON_FACEBOOK,
  ICON_INSTAGRAM,
  ICON_LINKEDIN,
  ICON_MAIL,
  ICON_PHONE,
  ICON_VIMEO,
  ICON_XING,
  ICON_YOUTUBE,
} from '~/utils/icon';

const { trackEvent } = useGtmTracking();

const props = defineProps<{
  blok: UtilLinkItemStoryblok;
  isDark?: boolean;
  trackClick?: boolean;
  detectIcon?: boolean;
}>();

const iconPosition = computed(() => {
  if (icon.value === ICON_EXTERNAL) {
    return 'right';
  }

  return 'left';
});

const icon = computed(() => {
  if (props.detectIcon) {
    if (props.blok.link?.url.includes('tel:')) {
      return ICON_PHONE;
    }

    if (props.blok.link?.url.includes('youtube')) {
      return ICON_YOUTUBE;
    }

    if (props.blok.link?.url.includes('mailto:')) {
      return ICON_MAIL;
    }

    if (props.blok.link?.url.includes('linkedin')) {
      return ICON_LINKEDIN;
    }

    if (props.blok.link?.url.includes('facebook')) {
      return ICON_FACEBOOK;
    }

    if (props.blok.link?.url.includes('vimeo')) {
      return ICON_VIMEO;
    }

    if (props.blok.link?.url.includes('insta')) {
      return ICON_INSTAGRAM;
    }

    if (props.blok.link?.url.includes('xing')) {
      return ICON_XING;
    }
  }

  if (props.blok.link?.linktype === 'url' && urlIsExternal(props.blok.link.url)) {
    return ICON_EXTERNAL;
  }
  return null;
});

function trackNavigationClick(label: string) {
  trackEvent({ event: 'navigationClick', navigationItem: label });
}
</script>

<style src="./UtilLinkItem.scss" lang="scss" scoped />
